import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

const CanvasBuilder = lazy(() =>
  import('@/components/agents/canvas/canvas-builder').then((mod) => ({
    default: mod.CanvasBuilder,
  }))
);

export const Route = createFileRoute('/_dashboard/agents/create/canvas')({
  component: CanvasBuilderPage,
});

function CanvasBuilderPage() {
  // Full-height layout within dashboard content area
  // Uses negative margins to break out of the p-6 padding from DashboardLayout
  return (
    <div className="-m-6 h-[calc(100vh-4rem)]">
      <Suspense fallback={<CanvasBuilderSkeleton />}>
        <CanvasBuilder className="h-full w-full" />
      </Suspense>
    </div>
  );
}

function CanvasBuilderSkeleton() {
  return (
    <div className="h-full w-full flex">
      {/* Node palette skeleton */}
      <div className="w-64 border-r p-4 space-y-4">
        <Skeleton className="h-8 w-full" />
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-full" />
      </div>
      {/* Canvas skeleton */}
      <div className="flex-1 bg-muted/30 flex items-center justify-center">
        <Skeleton className="h-32 w-48 rounded-lg" />
      </div>
      {/* Config panel skeleton */}
      <div className="w-80 border-l p-4 space-y-4">
        <Skeleton className="h-8 w-full" />
        <Skeleton className="h-24 w-full" />
        <Skeleton className="h-12 w-full" />
      </div>
    </div>
  );
}
